import './orderStatusConfirmationInfo.css';
import { useTranslation } from 'react-i18next';
import { constants } from '../constants/constants';
import { BllinkLogger } from '../utils/bllink_loggers';
import React from 'react';
import BllinkUtils from '../utils/utils';

export function OrderStatusConfirmationInfo(props) {

  const { t } = useTranslation();
  const { paymentDetails, cartID, isExpense } = props;

  const statuses = constants.PaymentPlanDetailsStatus;
  const status = paymentDetails.state;

  if (statuses.CANCELED.includes(status)) {
    return (
      <div className="mid-sec-Div d-flex">
        <div className="col-md-6 right-para">
          <p>{t('payments.canceled_deal')}</p>
        </div>
      </div>
    );
  }

  if (!isExpense && !statuses.ALL_SUCCESS.includes(status)){
    return (
      <div className="mid-sec-Div d-flex">
        <div className="col-md-6 right-para">
          <p>{t('payments.no_confirmation_yet')}</p>
        </div>
      </div>
    );
  }

  const dateParsed = BllinkUtils.BllinkTime.parseDate(paymentDetails.date);

  let cardIssuerText = '';
  let dataIssuer = paymentDetails.issuer || '-';
  let fourDigits = <p>{t('payments.4_last_digits')}</p>;
  let fourDigitDesktop = <p className="d-none d-md-block">{paymentDetails.last_4_digits} **** **** ****</p>;
  let fourDigitMobile = <p className="d-sm-block d-md-none">{paymentDetails.last_4_digits} **** **** </p>;
  let confirmationNumbers;
  let confirmationNumbersText;

  const { paymentMethods } = constants.APIContract;
  const isOfflinePayment = paymentMethods.offlinePayments.includes(paymentDetails.paymentMethodId);
  const isTenantRecord = paymentDetails.paymentMethodId === paymentMethods.tenantRecord;
  const isBankCharge = paymentDetails.paymentMethodId === paymentMethods.bankCharge;
  const isAutoDepositCharge = paymentDetails.paymentMethodId === paymentMethods.autoCheque;
  if (isOfflinePayment) {
      cardIssuerText = <p>{t('offline_payments.type_of_payment')}</p>;
      dataIssuer = t(`common.paymentMethods.${paymentDetails.paymentMethodId}`);
      fourDigits = fourDigitDesktop = fourDigitMobile = '';
  } else if (isBankCharge) {
    cardIssuerText = <p>{t('payments.payment_method')}</p>;
    dataIssuer = t(`offline_payments.bankCharge`);
    fourDigits = fourDigitDesktop = fourDigitMobile = '';
  } else if (isTenantRecord) {
    cardIssuerText = <p>{t('payments.payment_method')}</p>;
    dataIssuer = t(`offline_payments.tenant_record`);
  } else if (isAutoDepositCharge) {
    cardIssuerText = <p>{t('payments.payment_method')}</p>;
    dataIssuer = t(`buildings.autoCheque`);
  } else {
    cardIssuerText = <p>{t('payments.card_type')}</p>;
  }

  if (paymentDetails.confirmationNumbers) {
    BllinkLogger.info('adding ', paymentDetails.confirmationNumbers);
    confirmationNumbers = <p className={"confirmation-numbers"}>{paymentDetails.confirmationNumbers.join()}</p>;
    confirmationNumbersText = <p>{t('payments.confirmationNumbersText')}</p>;
  }

  return (
    <div className="mid-sec-Div d-flex">
      <div className="col-md-6 right-para">
        {fourDigits}

        {cardIssuerText}
        <p>{t('payments.transaction_date')}</p>
        <p>{t('payments.confirmation_id')}</p>
        {confirmationNumbersText}
      </div>
      <div className="col-md-6 left-para">
        {/* show shorter on mobile only, show longer on desktop only  */}
        {fourDigitDesktop}
        {fourDigitMobile}

        <p>{dataIssuer}</p>
        <p className="transaction-date-mobile">{dateParsed}</p>
        <p>{cartID}</p>
        {confirmationNumbers}
      </div>
    </div>
  );

}
